module.exports = __webpack_public_path__ + "media/images/gateway/sepectro-0a177a959812b3556ac553767886db19.png";